<ion-header class="extendido" *ngIf="loaded">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title *ngIf="!isTestemunho">{{'Novo pedido de ' | translate}}{{'oracao' | nomenclatura | async}}</ion-title>
    <ion-title *ngIf="isTestemunho">{{'Novo ' | translate}}{{'testemunho' | nomenclatura | async}}</ion-title>
  </ion-buttons>
</ion-header>

<app-loading-spinner *ngIf="!loaded"></app-loading-spinner>

<ion-content *ngIf="loaded">
  <div class="gradient-extendido"></div>
  <div class="div-imagem-extendido">
    <img [src]="pessoa.foto | image:' '" class="image-extendido" />

    <h2 text-capitalize margin-top class="nome-pessoa bold-2">
      {{pessoa.id ? pessoa.nome : ("Nenhuma Pessoa Selecionada" | translate)}}
    </h2>
  </div>

  <form
    class="sample-form validations-form"
    [formGroup]="validations_form"
    (ngSubmit)="onSubmit(validations_form.value)"
  >
    <ion-grid>
      <ion-row>
        <ion-col class="ion-margin">
          <ion-label *ngIf="!isTestemunho">
            <i class="fa-solid fa-hands-praying" style="color: var(--theme-color4);"></i>{{'Pedido de ' | translate}}{{'oracao' | nomenclatura | async}}
          </ion-label>

          <ion-label *ngIf="isTestemunho">
            <i class="fa-solid fa-hands-praying" style="color: var(--theme-color4);"></i>{{'Testemunho' | nomenclatura | async}}
          </ion-label>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col class="ion-margin linha-horizontal">
          <ion-textarea rows="6" cols="60" type="text" formControlName="pedido"></ion-textarea>
        </ion-col>
      </ion-row>
    </ion-grid>

    <div class="validation-errors">
      <ng-container *ngFor="let validation of validation_messages.pedido">
        <div
          class="error-message"
          *ngIf="validations_form.get('pedido')?.hasError(validation.type) && (validations_form.get('pedido')?.dirty || validations_form.get('pedido')?.touched)"
        >
          {{ validation.message }}
        </div>
      </ng-container>
    </div>

    <div class="remove-border">
      <ion-grid>
        <ion-row class="ion-margin-start ion-margin-end">
          <ion-col size="4" style="margin: auto">
            <p>{{'Pedido público' | translate}}</p>
          </ion-col>

          <ion-col size="2" style="margin: auto">
            <ion-toggle [enableOnOffLabels]="true" [(ngModel)]="publico" formControlName="publico"></ion-toggle>
          </ion-col>

          <ion-col size="6">
            <ion-button
              expand="block"
              class="btn-success"
              style="width: 9rem; font-size: 13px; margin: auto"
              type="submit"
              [disabled]="!validations_form.valid || !pessoa.id"
            >
              <div>{{'Enviar' | translate}}</div>
            </ion-button>
          </ion-col>
        </ion-row>
      </ion-grid>

      <ion-grid *ngIf="publico">
        <ion-row class="ion-no-margin">
          <ion-col>
            <p class="info-lgpd" *ngIf="!isTestemunho">
              {{'Ao enviar um pedido público, outras pessoas poderão ver' | translate}}
            </p>
            <p class="info-lgpd" *ngIf="isTestemunho">
              {{'Ao enviar um testemunho público, outras pessoas poderão ver' | translate}}
            </p>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
  </form>

  <div class="text-lgpd">
    <span>
      {{ 'O usuário é o único responsável pelo conteúdo inserido no sistema, podendo ser responsabilizado administrativamente, civilmente e/ou criminalmente por quaisquer violações legais contidas no texto' | translate}}
    </span>
  </div>
</ion-content>
